import { FunctionComponent, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import track from 'c9-tracking';

import * as HippoPreview from './classes/HippoPreview';
import * as ActionKeys from './store/ActionKeys';
import { loadApplicationAppData } from './store/Actions';
import { useStateValue } from './hooks/UseStateValue';

import { FormContainer } from './containers/FormContainer/FormContainer';
import splash from './assets/png/splash.png';

import { useStyles } from './App.styles';
import './assets/styles/app.css';

const App: FunctionComponent<any> = (props): JSX.Element => {
  const location = useLocation();
  const [{ isLoadingComplete }, dispatch] = useStateValue();
  const classes = useStyles();

  const isCMSPreviewMode = useMemo(() => HippoPreview.checkIsCMSPreviewMode(props), [props]);

  useEffect(() => {
    dispatch({ type: ActionKeys.SET_PREV_ROUTE_CONFIG, payload: location });
  }, [dispatch, location]);

  useEffect(() => {
    //If in preview mode don't try to load data
    if (!isCMSPreviewMode) {
      loadApplicationAppData(props, dispatch);
    }

    track.ready(true);
  }, [props, isCMSPreviewMode, dispatch]);

  return (
    <>
      {isLoadingComplete ? (
        <FormContainer {...props} />
      ) : (
        <div className={classes.root}>
          <div className="onsa-main-wrapper">
            <div className="onsa-content-area">
              <div className="onsa-main-inner-wrapper">
                {isCMSPreviewMode ? <img src={splash} alt="splash" /> : <CircularProgress className="app-loader" />}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default App;
